import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'
import Axios from '@/axios'
import Api from './Api'

const axios = new Axios()
const instance = axios.instance
axios.setRequestInterceptors(Axios.requestInterceptors.stringifyParams)
axios.setResponseInterceptors(Axios.responseInterceptors.getData)

const decodeData = res => {
  const fn = string => {
    const $key = Utf8.parse('0n1jcAGW3UgyOB7XorYLyauj')
    const $iv = Utf8.parse('41yBvl7Thdo2Z0qN')
    // 默认cbc Pkcs7
    return AES.decrypt(string, $key, {
      iv: $iv
    }).toString(Utf8)
  }

  return JSON.parse(fn(res))
}

export function writeLog(params) {
  // return instance.post(Api().writeLog, params, {
  //   withCredentials: false
  // })
  return () => {}
}

export async function getCfg(params) {
  const res = await instance.get(Api().getCfg, {
    withCredentials: false,
    params: params
  })
  return decodeData(res)
}

export function readToken(params) {
  return instance.post(Api().readToken, params)
}

export function getRegInfo(params) {
  //   return instance.get(Api().getRegInfo, { params: params })
  return () => {}
}

export function preLogin(params) {
  //   return instance.post(Api().preLogin, params)
  return () => {}
}

export function tpreLogin(params) {
  //   return instance.post(Api().tpreLogin, params)
  return () => {}
}

export function hpreLogin(params) {
  //   return instance.post(Api().hpreLogin, params)
  return () => {}
}

export function unifyLogin(params) {
  return instance.post(Api().login, params)
}

export function getVerificationCode(params) {
  return instance.post(Api().fpSendMsg, params)
}

export function verifyVerificationCode(params) {
  return instance.post(Api().fpGetVerify, params)
}

export function resetPassword(params) {
  return instance.post(Api().fpResetPwd, params)
}

export function activation(params) {
  return instance.post(Api().activation, params)
}

export function getCountryList(params) {
  return instance.post(Api().getCountry, params)
}

export function getSchool(params) {
  return instance.post(Api().getSchoolByCountryIdStu, params)
}

export function getCategorys(params) {
  return instance.post(Api().getGradeBySchoolIdNoCount, params)
}

export function getClass(params) {
  return instance.post(Api().getClassByCategoryId, params)
}

export function savePerStuInfo(params) {
  return instance.post(Api().savePerStuInfo, params)
}

export function addOneFeedback(params) {
  return instance.post(Api().addOneFeedback, params)
}

export function sendMessage(params) {
  return instance.post(Api().sendMessage, params)
}

export function savePerInfo(params) {
  return instance.post(Api().post, params)
}

export function removedLog(params) {
  return instance.post(Api().removedLog, params)
}

export function confirgue(params) {
  return instance.post(Api().confirgue, params)
}

export function checkAuth(params) {
  return instance.get(Api().checkAuth, { params: params })
}

export function loginHeart(params) {
  return instance.post(Api().loginHeart, params)
}

export function validate(params) {
  return instance.post(Api().validate, params)
}

export function validateClassCode(params) {
  return instance.post(Api().validateClassCode, params)
}

export function authValidateClassCode(params) {
  return instance.post(Api().authValidateClassCode, params)
}

export function register(params) {
  return instance.post(Api().register, params)
}

export function authStore(params) {
  return instance.post(Api().authStore, params)
}

export function province(params) {
  return instance.get(Api().province, { params: params })
}

export function city(params) {
  return instance.get(Api().city, { params: params })
}

export function district(params) {
  return instance.get(Api().district, { params: params })
}

export function grade(params) {
  return instance.get(Api().grade, { params: params })
}

export function preDefaultRegion(params) {
  return instance.get(Api().preDefaultRegion, { params: params })
}

export function authEnter(params) {
  return instance.get(Api().authEnter, { params: params })
}

export default function install(vue) {
  vue.prototype.$http = instance
}



// WEBPACK FOOTER //
// ./src/api/index.js